import { routePaths } from 'appConfig';
import cn from 'classnames';
import { Link } from 'components/common';
import {
  ProductCategory,
  SpecialProductCategory,
} from 'lib/productCategory';
import { pathToTo } from 'lib/router';
import { useRouter } from 'next/router';
import TagsFilter from './TagsFilter';
import { CollectionMenu } from './types';

const ProductCategoriesSidebar = ({
  className,
  collections,
  categories,
  specialProductCategories,
  isTieredUser,
  isLoading,
}: {
  className?: string;
  collections: CollectionMenu[];
  categories: ProductCategory[];
  specialProductCategories: SpecialProductCategory[];
  isTieredUser?: boolean;
  isLoading?: boolean;
}) => {
  const { query, push, pathname } = useRouter();

  const { tag_ids } = query;

  const setQueryParams = (queryParams) => {
    push(
      {
        pathname,
        query: queryParams,
      },
      // @ts-ignore
      null,
      { shallow: true },
    );
  };

  return (
    <aside className={cn('tw-w-full tw-flex tw-flex-col', className)}>
      <div className="tw-flex tw-flex-col tw-space-y-4">
        {categories.map((category) => {
          // @ts-ignore
          const to = pathToTo(routePaths.PRODUCTS, {
            // @ts-ignore
            queryParams: { category_ids: category.id.split(',') },
          });

          const queryCategoryIds = Array.isArray(query.category_ids)
            ? query.category_ids
            : query.category_ids?.split(',') ?? [];
          const categoryId = category.id.split(',');

          const isActive = queryCategoryIds.some((id) =>
            categoryId.includes(id),
          );

          return (
            <Link
              to={to}
              key={category.id}
              exact="query"
              shallow
              style={{ color: 'unset' }}
              className="tw-font-bold tw-leading-tight"
              activeClassName="tw-text-primary"
            >
              <div className="tw-flex tw-items-center tw-gap-2">
                {isActive && <i className="icon-long-arrow-right" />}
                {category.name}
              </div>
            </Link>
          );
        })}
      </div>
      {collections.length && (
        <>
          <hr className="tw-w-full tw-my-4" />
          <div className="tw-flex tw-flex-col tw-space-y-4">
            {collections.map((collection) => {
              // @ts-ignore
              const to = pathToTo(routePaths.PRODUCTS, {
                // @ts-ignore
                queryParams: {
                  collection_ids: collection.id,
                },
              });

              return (
                <Link
                  to={to}
                  key={collection.id}
                  exact="query"
                  shallow
                  style={{ color: 'unset' }}
                  className="tw-font-bold tw-leading-tight"
                  activeClassName="tw-text-primary"
                >
                  <div className="tw-flex tw-items-center tw-gap-2">
                    {query.collection_ids === collection.id && (
                      <i className="icon-long-arrow-right" />
                    )}
                    {collection.name}
                  </div>
                </Link>
              );
            })}
          </div>
        </>
      )}
      {specialProductCategories.length > 0 && (
        <>
          <hr className="tw-w-full tw-my-4" />
          <div className="tw-flex tw-flex-col tw-space-y-4">
            {specialProductCategories.map((category) => {
              // @ts-ignore
              const to = pathToTo(routePaths.PRODUCTS, {
                // @ts-ignore
                queryParams: { category_ids: category.id.split(',') },
              });

              return (
                <Link
                  to={to}
                  key={category.id}
                  exact="query"
                  shallow
                  style={{ color: 'unset' }}
                  className="tw-font-bold tw-leading-none"
                  activeClassName="tw-text-primary"
                >
                  <div className="tw-flex tw-items-center tw-gap-2">
                    {query.category_ids?.includes(category.id) && (
                      <i className="icon-long-arrow-right" />
                    )}
                    {isLoading ? null : isTieredUser ? (
                      <i className="la la-star tw-text-[14px] tw-shrink-0" />
                    ) : (
                      <i className="fa fa-lock tw-text-[14px] tw-shrink-0" />
                    )}
                    {category.name}
                  </div>
                </Link>
              );
            })}
          </div>
        </>
      )}
      <hr className="tw-w-full tw-my-4" />
      <div className="tw-py-8">
        <TagsFilter
          // @ts-ignore
          value={tag_ids}
          onChange={(newValue) => {
            setQueryParams({ ...query, tag_ids: newValue });
          }}
          onClear={() => {
            const newQuery = { ...query };
            delete newQuery.tag_ids;

            setQueryParams({ ...newQuery });
          }}
          condensed
        />
      </div>
    </aside>
  );
};

export default ProductCategoriesSidebar;
